export default __webpack_public_path__ + "static/media/iphone.d8f52485.png";